import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import EventInProgressListWrap from './EventInProgressListWrap';
import { EVENT_LIST_FILTER_OPTION_MODEL } from '../../../store/modules/event/models';
import { LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import useExcel from './hook/useExcel';
import useEventInProgressListUtils from './hook/useEventInProgressListUtils';
import useEventInProgressListViewModel from './hook/useEventInProgressListViewModel';

function EventInProgressListContainer() {
  const { inProgressEvent } = useSelector((state) => state.event);

  const { setInitialInProgressEventList, openEventItemListModal } = useEventInProgressListUtils(inProgressEvent);
  const { getInProgressEventList, getEventTagColumnTagList } = useEventInProgressListViewModel(inProgressEvent);
  const { getInProgressEventExcelDownload } = useExcel(inProgressEvent);

  useEffect(() => {
    getInProgressEventList({
      filterOption: EVENT_LIST_FILTER_OPTION_MODEL,
      pagination: LIST_PAGINATION_MODEL,
    });
  }, []);

  return (
    <EventInProgressListWrap
      inProgressEvent={inProgressEvent}
      getInProgressEventList={getInProgressEventList}
      getInProgressEventExcelDownload={getInProgressEventExcelDownload}
      openEventItemListModal={openEventItemListModal}
      getEventTagColumnTagList={getEventTagColumnTagList}
      setInitialInProgressEventList={setInitialInProgressEventList}
    />
  );
}

export default EventInProgressListContainer;
